import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTransactionTaxCollectionStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionTaxCollectionStatus = useQuery(
    ['getTransactionTaxCollectionStatus'],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTaxCollectionStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionTaxCollectionStatus;
};

export default useGetTransactionTaxCollectionStatus;
